import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueGtag from "vue-gtag";
import vSelect from "vue-select";
import GameplanLocker from '@axlot-team/gameplan-locker';
import DefaultLayout from './layouts/DefaultLayout'
import DashboardLayout from './layouts/DashboardLayout'
import "@axlot-team/gameplan-locker/dist/gameplan-locker.css";
import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);
Vue.component("default-layout", DefaultLayout);
Vue.component("dashboard-layout", DashboardLayout);
Vue.use(GameplanLocker, { store })

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_ANALYTICS_KEY_LOCAL : process.env.VUE_APP_ANALYTICS_KEY }
});

const app = new Vue({
  router,
  store,
  render: h => h(App)
})


router.onReady(() => {
  app.$mount('#app')
})